import { IObject } from "@quest/base-core";

export let eventDispatchers: IObject = {
  SHOW_BOTTOM_BAR_LOGO: "SHOW_BOTTOM_BAR_LOGO",
  
  PLAY_MUSIC_SPIN: "PLAY_MUSIC_SPIN",
  CREATE_WIN_MASK: "CREATE_WIN_MASK",
  CREATE_ONION_MASK:"CREATE_ONION_MASK",
  REMOVE_ONION_MASK:"REMOVE_ONION_MASK",
  // reel shift effect
  SHIFT_REEL_TO_LEFT: "SHIFT_REEL_TO_LEFT",
  SHIFT_REEL_TO_RIGHT: "SHIFT_REEL_TO_RIGHT",
  // SHOW_BG_LOOP_ON_BET_CHANGE:"SHOW_BG_LOOP_ON_BET_CHANGE",
  // HIDE_BG_LOOP_ON_BET_CHANGE:"HIDE_BG_LOOP_ON_BET_CHANGE",
  
  //wild
  STORE_GRID_WITH_BET: "STORE_GRID_WITH_BET",
  PURPLE_TO_GOLD_WILD_ANIM: "PURPLE_TO_GOLD_WILD_ANIM",
  SHOW_PURPLE_FLOWER_CONTAINER_TO_GOLDEN: "SHOW_PURPLE_FLOWER_CONTAINER_TO_GOLDEN",
  REMOVE_WILD_FROM_REEL: "REMOVE_WILD_FROM_REEL",
  UPDATE_GRID_ON_LAST_WILD: "UPDATE_GRID_ON_LAST_WILD",
  SHOW_ANIM_REEL: "SHOW_ANIM_REEL",
  SHOW_MINI_SKULL_ANIMS: "SHOW_MINI_SKULL_ANIMS",
  "HANDLE_TINT_WILD_SKULLS": "HANDLE_TINT_WILD_SKULLS",
  // RESET_MINI_SKULL_ANIMATIONS: "RESET_MINI_SKULL_ANIMATIONS",
  //  FREE MONKEY STACK FEATURE
  SET_STACK_SPINE_PAUSE: "SET_STACK_SPINE_PAUSE",

  //selection screen
  SEND_FREE_GAME_SELECTION_REQUEST: "SEND_FREE_GAME_SELECTION_REQUEST",
  PARSE_FREE_GAME_RESPONSE_AFTER_REQUEST: "PARSE_FREE_GAME_RESPONSE_AFTER_REQUEST",
  DESTROY_SELECTION_SCREEN: "DESTROY_SELECTION_SCREEN",
  INITIALIZE_SELECTION_SCREEN: "INITIALIZE_SELECTION_SCREEN",
  SHOW_SELECTION_SCREEN: "SHOW_SELECTION_SCREEN",

  //STACK SYMBOL
  INITIALIZE_BASEGAME_STACK_FEATURE: "INITIALIZE_BASEGAME_STACK_FEATURE",
  SHOW_LARGE_STACK_SYMBOL: "SHOW_LARGE_STACK_SYMBOL",
  HIDE_LARGE_STACK_SYMBOL: "HIDE_LARGE_STACK_SYMBOL",
  STOP_STACK_SYM_ANIM: "STOP_STACK_SYM_ANIM",
  INITIALIZE_FREEGAME_STACK_FEATURE: "INITIALIZE_FREEGAME_STACK_FEATURE",
  SHOW_LARGE_STACK_SYMBOL_FG: "SHOW_LARGE_STACK_SYMBOL_FG",
  HIDE_LARGE_STACK_SYMBOL_FG: "HIDE_LARGE_STACK_SYMBOL_FG",
  PLAY_STACK_SYM_ANIM_FG: "PLAY_STACK_SYM_ANIM_FG",
  STOP_STACK_SYM_ANIM_FG: "STOP_STACK_SYM_ANIM_FG",
  STOP_STACK_ANIM_WITH_LINE_WIN: "STOP_STACK_ANIM_WITH_LINE_WIN",
  HIDE_BLUR_BG: "HIDE_BLUR_BG",
  PLAY_STACK_WIN_ANIMATION_ON_TOGGLE:  "PLAY_STACK_WIN_ANIMATION_ON_TOGGLE",
  HIDE_STATIC_SYMBOL_BEHIND_STACK: "HIDE_STATIC_SYMBOL_BEHIND_STACK",
  HIDE_STATIC_SYMBOL_BEHIND_STACK_FG: "HIDE_STATIC_SYMBOL_BEHIND_STACK_FG",
  PLAY_STACK_WIN_ANIMATION: "PLAY_STACK_WIN_ANIMATION",
  PLAY_STACK_WIN_ANIMATION_FG:"PLAY_STACK_WIN_ANIMATION_FG",
  SHOW_STATIC_SYMBOL_BEHIND_STACK: "SHOW_STATIC_SYMBOL_BEHIND_STACK",
  SHOW_STATIC_SYMBOL_BEHIND_STACK_FG: "SHOW_STATIC_SYMBOL_BEHIND_STACK_FG",

  //sticky wild 
  SHOW_STICKY_WILD_ON_REEL_FG: "SHOW_STICKY_WILD_ON_REEL_FG",
  START_FG_FIRST_SPIN: "START_FG_FIRST_SPIN",
  START_STICKY_WILD_FG: "START_STICKY_WILD_FG",
  INITIALIZE_WILD_REELS_FG_VIEW: "INITIALIZE_WILD_REELS_FG_VIEW",
  SHOW_PURPLE_FRAME: "SHOW_PURPLE_FRAME",
  WILD_LANDED_ON_REEL: "WILD_LANDED_ON_REEL",
  HIDE_REEL_BEHIND_WILD_BG: "HIDE_REEL_BEHIND_WILD_BG",
  SHOW_STICKY_WILD_ON_BROKEN:"SHOW_STICKY_WILD_ON_BROKEN",
  SHOW_STATIC_STICKY_WILD:"SHOW_STATIC_STICKY_WILD",
  //LOGIC
  SHOW_NEXT_FEATURE_PRESENTATION: "SHOW_NEXT_FEATURE_PRESENTATION",
  ADD_DISABLED_ONION_ON_REEL: "ADD_DISABLED_ONION_ON_REEL",

  // collect feature
  HANDLE_FLOWERS_ON_BET_CHANGE: "HANDLE_FLOWERS_ON_BET_CHANGE",
  INITIALIZE_FLOWER_ONION_TRAIL: "INITIALIZE_FLOWER_ONION_TRAIL",
  SHOW_FLOWER_TRAIL: "SHOW_FLOWER_TRAIL",
  SHOW_COLLECTED_FLOWERS_ON_PANEL: "SHOW_COLLECTED_FLOWERS_ON_PANEL",
  PLAY_ONION_EFFECT: "PLAY_ONION_EFFECT",
  COLLECTED_FLOWERS_ON_BET_CHANGE: "COLLECTED_FLOWERS_ON_BET_CHANGE",
  COLLECTED_FLOWERS_ON_BROKEN: "COLLECTED_FLOWERS_ON_BROKEN",
  RESET_FLOWER_PANEL_ANIMATION: "RESET_FLOWER_PANEL_ANIMATION",
  RESET_FLOWER_PANEL: "RESET_FLOWER_PANEL",
  HANDLE_FEATURE_ON_BET_CHANGE: "HANDLE_FEATURE_ON_BET_CHANGE",
  HANDLE_FEATURE_ON_BROKEN: "HANDLE_FEATURE_ON_BROKEN",
  //wild
  INITIALIZE_WILD_DRAGON: "INITIALIZE_WILD_DRAGON",
  START_WILD_DRAGON_FEATURE: "START_WILD_DRAGON_FEATURE",
  RESET_GLOW_EFFECT_ANIMATION: "RESET_GLOW_EFFECT_ANIMATION",
  PLAY_WILD_WIN_ANIM: "PLAY_WILD_WIN_ANIM",
  HIDE_REEL_BEHIND_WILD_FG: "HIDE_REEL_BEHIND_WILD_FG",
  SUPSPEPND_WILD_WIN: "SUPSPEPND_WILD_WIN",
  PLAY_WILD_DRAGON_WIN_ANIM: "PLAY_WILD_DRAGON_WIN_ANIM",
  PLAY_EAT_FLOWER_ANIM: "PLAY_EAT_FLOWER_ANIM",
  EAT_FLOWER_BY_DRAGON: "EAT_FLOWER_BY_DRAGON",
  SUPSPEPND_WILD_DRAGON_WIN: "SUPSPEPND_WILD_DRAGON_WIN",
  RESET_WILD_ON_REEL:"RESET_WILD_ON_REEL",
  COLLECTED_WILD_ON_BET_CHANGE:"COLLECTED_WILD_ON_BET_CHANGE",
  COLLECTED_WILD_ON_BROKEN:"COLLECTED_WILD_ON_BROKEN",
  ENABLE_ANIM_REEL_ON_BET_CHANGE:"ENABLE_ANIM_REEL_ON_BET_CHANGE",
  HANDLE_FEATURE_ON_REFRESH:"HANDLE_FEATURE_ON_REFRESH",
  HANDLE_TINT_WILD_SYMBOL:"HANDLE_TINT_WILD_SYMBOL",
  HANDLE_WILD_REEL_DURING_TOGGLE:"HANDLE_WILD_REEL_DURING_TOGGLE",

  // portrait handle
  HIDE_BASE_GAME_PORTRAIT_WIN_MTR: "HIDE_BASE_GAME_PORTRAIT_WIN_MTR",
  SHOW_BASE_GAME_PORTRAIT_WIN_MTR: "SHOW_BASE_GAME_PORTRAIT_WIN_MTR",

  //top logo
  HIDE_TOP_LOGO_ON_SELECTION_SCREEN:"HIDE_TOP_LOGO_ON_SELECTION_SCREEN",
  SHOW_TOP_LOGO_ON_SELECTION_SCREEN:"SHOW_TOP_LOGO_ON_SELECTION_SCREEN",


  //
  REMOVE_SCATTER_AFTER_LANDING:"REMOVE_SCATTER_AFTER_LANDING",
  SHOW_BET_CHANGE_MSG:"SHOW_BET_CHANGE_MSG",
  HIDE_BET_CHANGE_MSG:"HIDE_BET_CHANGE_MSG",
  RESET_TOGGLE_SOUND_COUNTER: "RESET_TOGGLE_SOUND_COUNTER",

  FULL_SCREEN_GAME:"FULL_SCREEN_GAME",
  DISABLE_FULL_SCREEN_GAME:"DISABLE_FULL_SCREEN_GAME",
  SHOW_TOP_BAR:"SHOW_TOP_BAR",
  RESIZE_CANVAS: "RESIZE_CANVAS",
  ADD_TOP_BAR_ON_TOP:"ADD_TOP_BAR_ON_TOP",
  ADD_TOP_VIEW_ON_TOP: "ADD_TOP_VIEW_ON_TOP",
  RESIZE_SETTING_PANEL_ON_ORIENTATION:"RESIZE_SETTING_PANEL_ON_ORIENTATION"

};
